import { http } from "./config";

export default {
  listar: (loja) => {
    var query = loja!=""?`?cd_loja=${loja}`:""
    console.log("cardapio.php"+query)
    return http.get("cardapio.php"+query);
  },
};
